var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.links.length)?_c('div',_vm._l((_vm.links),function(link){return _c('v-btn',{key:link.label,staticClass:"mr-2",attrs:{"to":link.to,"x-small":"","outlined":"","color":"primary"}},[_vm._v(" "+_vm._s(link.label)+" ")])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }